const config = {
  infuraAPIKey: 'UIWcVZuPtuXHpAFglFyd',
  contractAddressDev: '0xf25186b5081ff5ce73482ad761db0eb0d25abfbf',
  contractAddressRopsten: '0xa7d1f40478208d2ed065c2ed09cb418d0fdceea0',
  contractAddressLive: '0xB6bbf89c3DbBa20Cb4d5cABAa4A386ACbbAb455e'
}

export default config



// WEBPACK FOOTER //
// ./src/config/index.js